import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SubscriptionDocumentListComponent} from './subscription-document-list.component';
import {SubscriptionDocumentListItemComponent} from './subscription-document-list-item/subscription-document-list-item.component';
import {PaginatorModule} from 'primeng/paginator';
import {DateModule, StoredFileModule} from '@lifeislife/lifeislife-components';


@NgModule({
  declarations: [SubscriptionDocumentListComponent, SubscriptionDocumentListItemComponent],
  exports: [SubscriptionDocumentListComponent, SubscriptionDocumentListItemComponent],
  imports: [
    CommonModule,
    PaginatorModule,
    StoredFileModule,
    DateModule,
  ],
})
export class SubscriptionDocumentListModule {
}
